import { SVGProps } from "react";

const ArrowUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={props.width ? props.width : "12"}
    height={props.height ? props.height : "18"}
    viewBox="0 0 12 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.75 0.75L5.75 16.75"
      stroke={props.stroke || "#141B34"}
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10.75 5.74996C10.75 5.74996 7.06756 0.750011 5.74996 0.75C4.43237 0.749989 0.75 5.75 0.75 5.75"
      stroke={props.color || "#141B34"}
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export default ArrowUp;
